import { Nav as _Nav, NavProps as _NavProps } from "reactstrap";

export const Nav = _Nav;
export type NavProps = _NavProps;
